import { render, staticRenderFns } from "./m-form-item.vue?vue&type=template&id=27b88aee&"
import script from "./m-form-item.vue?vue&type=script&lang=js&"
export * from "./m-form-item.vue?vue&type=script&lang=js&"
import style0 from "./m-form-item.vue?vue&type=style&index=0&id=27b88aee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports